import _ from 'lodash';
import {
  serviceServicesAddService,
  serviceServicesEditService,
  serviceServicesAddSubscription,
  serviceServicesEditSubscription,
} from '../../../../../../services/endpoints/services';

/**
 * ID сервисов с типом Package
 *
 * 10 - Package
 * 14 - Custom Comments Package
 * 16 - SEO Package
 */
export const getExceptionsTypes = () => [14, 10, 16];

/**
 * @name getModalName
 * @param {object|null} modalData
 * @description
 *
 * Title модалки
 * Варианты:
 * 1 - Add service
 * 2 - Edit service (ID)
 * 3 - Add subscription
 * 4 - Edit subscription (ID)
 *
 * @returns {string}
 */
export const getModalName = (modalData) => {
  if (modalData) {
    const modalType = Number(modalData.type) === 100 ? 'subscription' : 'service';
    if (modalData.id) {
      const { id } = modalData;
      return `Edit ${modalType} (ID: ${id})`;
    }
    return `Add ${modalType}`;
  }
  return 'Add service';
};

export const getSelectedService = (serviceId, providerForm) => {
  if (serviceId) {
    return providerForm?.provider_service_id?.options?.[serviceId];
  }
  return null;
};

export const getProviderFormService = (providerServiceId, providerForm) => {
  if (providerServiceId && providerForm) {
    if (providerForm.hasOwnProperty('provider_service_id')) {
      if (providerForm.provider_service_id?.options) {
        if (providerForm.provider_service_id.options?.[providerServiceId]) {
          return providerForm.provider_service_id.options[providerServiceId];
        }
      }
    }
  }
  return null;
};

export const getNumberWithMaxValue = (value, max) => {
  if (value.trim() === '') {
    return null;
  }

  if (/^[0-9\b]+$/.test(value)) {
    const maxValue = max || 999999999999;
    const valueNumber = parseInt(value, 10);
    let nextValue = valueNumber;
    if (valueNumber > maxValue) {
      nextValue = maxValue;
    }
    return nextValue;
  }

  return false;
};

export const getNumberValue = (value) => {
  if (value.trim() === '') {
    return null;
  }

  if (/^[0-9\b]+$/.test(value)) {
    const maxValue = 999999999999;
    const valueNumber = parseInt(value, 10);
    let nextValue = valueNumber;
    if (valueNumber > maxValue) {
      nextValue = maxValue;
    }
    return nextValue;
  }

  return false;
};

/**
 *
 * @name checkModalOnlySubscription
 * @param {object|null} modalData
 * @returns {boolean}
 */
export const checkModalOnlySubscription = (modalData) => {
  if (modalData) {
    const { type } = modalData;
    /**
     * 100 тип - это Subscription
     */
    if (Number(type) === 100) {
      return true;
    }
  }
  return false;
};

/**
 *
 * @name checkModalSubscription
 * @param {object|null} modalData
 * @returns {boolean}
 */
export const checkModalSubscription = (modalData) => {
  if (modalData) {
    const { type, fake_subscription } = modalData;
    /**
     * 100 тип - это Subscription
     */
    if (Number(type) === 100) {
      return true;
    }
    /**
     * fake_subscription - это обычный сервис, но показываем как Subscription
     */
    if (fake_subscription) {
      return true;
    }
  }
  return false;
};

/**
 *
 * @name checkFakeSubscription
 * @param {object|null} modalData
 * @returns {boolean}
 */
export const checkFakeSubscription = (modalData) => {
  if (modalData) {
    const { fake_subscription } = modalData;
    if (fake_subscription) {
      return true;
    }
  }
  return false;
};

/**
 * @name checkProviderServiceSubscription
 * @param {object|null} form
 * @param {object|null} providerForm
 * @returns {boolean}
 */
export const checkProviderServiceSubscription = (form, providerForm) => {
  if (form && providerForm) {
    const { mode, provider_service_id } = form;
    if (mode && provider_service_id) {
      const service = getProviderFormService(provider_service_id, providerForm);
      if (service) {
        if (service.hasOwnProperty('service_type')) {
          const { service_type } = service;
          if (Number(service_type) === 100 || Number(service_type) === 101) {
            return true;
          }
        }
      }
    }
  }
  return false;
};

export const getServiceNames = (form) => {
  if (form?.service_title) {
    const { service_title } = form;
    const name = {};
    if (_.isArray(service_title)) {
      service_title.forEach((title) => {
        const { language_code, value } = title;
        name[language_code] = value;
      });
    }
    return name;
  }
  return {};
};

export const getPayloadForm = (form) => {
  if (form) {
    let payload = _.cloneDeep(form);
    payload = _.omit(payload, ['service_title']);
    payload.name = getServiceNames(form);
    payload.category = form.category_id;
    return payload;
  }
  throw new Error('Not found form');
};

export const getSubmitFunction = (modal, form, providerForm) => {
  const isSubscription = checkModalSubscription(modal);
  const isEdit = modal?.id;
  const isServiceSubscription = checkProviderServiceSubscription(form, providerForm);

  if (isEdit) {
    if (isSubscription || isServiceSubscription) {
      return serviceServicesEditSubscription;
    }
    return serviceServicesEditService;
  }
  if (isSubscription || isServiceSubscription) {
    return serviceServicesAddSubscription;
  }
  return serviceServicesAddService;
};

export const checkTestPanel = () => {
  const domains = ['andrew-panel.mypanel.link'];
  return domains.includes(window.location.hostname)
}
